export const destructureData = (data) => {
  const {
    name,
    description,
    route: surveyRoute,
    status,
    expiry_date: expiryDate,
    need_validation: needsValidation,
    identificator_type: identificationType,
    survey_id: surveyId,
    has_consent: hasConsent,
    requires_password: requiresPassword,
    consent_body: consentBody,
  } = data;

  const surveyMetadata = {
    name,
    description,
    surveyRoute,
    status,
    expiryDate,
    needsValidation,
    identificationType,
    surveyId,
    hasConsent,
    requiresPassword,
    consentBody,
  };

  const welcomeData = data.welcome;
  const generalInfoData = data.generalInfos;

  return { surveyMetadata, welcomeData, generalInfoData };
};
